import { render, staticRenderFns } from "./ReadTracking.vue?vue&type=template&id=4afad9b0&scoped=true"
import script from "./ReadTracking.vue?vue&type=script&lang=js"
export * from "./ReadTracking.vue?vue&type=script&lang=js"
import style0 from "./ReadTracking.vue?vue&type=style&index=0&id=4afad9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afad9b0",
  null
  
)

export default component.exports